import React from "react";
import PropTypes from "prop-types";
import {
  StrategyTab,
  StrategyIcon,
  StrategyLogo,
} from "./StrategyTreemap.styles";

const StrategyTabItem = ({
  strategy,
  index,
  activeStrategyIndex,
  onStrategyChange,
}) => {
  const name = typeof strategy === "string" ? strategy : strategy.name;
  const iconUrl = typeof strategy === "object" ? strategy.iconUrl : null;
  const logo =
    typeof strategy === "object"
      ? strategy.logo
      : strategy.charAt(strategy.length - 1);
  const key = typeof strategy === "object" ? strategy.id || name : name;

  return (
    <StrategyTab
      key={key}
      $isActive={index === activeStrategyIndex}
      onClick={() => onStrategyChange?.(index)}
    >
      {iconUrl && (
        <StrategyIcon
          src={iconUrl}
          alt={name}
          onError={(e) => {
            e.target.style.display = "none";
            if (e.target.nextSibling)
              e.target.nextSibling.style.display = "flex";
          }}
        />
      )}
      <StrategyLogo $hidden={!!iconUrl}>{logo}</StrategyLogo>
      {name}
    </StrategyTab>
  );
};

StrategyTabItem.propTypes = {
  strategy: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string.isRequired,
      iconUrl: PropTypes.string,
      logo: PropTypes.string,
    }),
  ]).isRequired,
  index: PropTypes.number.isRequired,
  activeStrategyIndex: PropTypes.number.isRequired,
  onStrategyChange: PropTypes.func,
};

export default StrategyTabItem;
